import { IUpdateShippingPriceDTO } from '@/models/shippingPrice.model';

class UpdateShippingPricesDTO implements IUpdateShippingPriceDTO {
  id: string;

  price: number;

  taxExemptRegion: boolean;

  constructor({ id, price, taxExemptRegion }: { id: string; price: string; taxExemptRegion: boolean }) {
    this.id = id;

    this.price = Number.parseFloat(price);

    this.taxExemptRegion = taxExemptRegion;
  }
}

export default UpdateShippingPricesDTO;
